import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    standalone: true,
    imports: [NgIf, TooltipModule, MomentModule],
    selector: 'qwyk-relative-time-display',
    templateUrl: './relative-time-display.component.html',
    styleUrls: ['./relative-time-display.component.scss'],
})
export class RelativeTimeDisplayComponent {
    @Input() value?: string;
}
